module.exports = __webpack_public_path__ + "img/na.ae6dd4fa.jpg";